import request from '@/utils/request'

const base = '/db/entry-details-info';

// 分页查询
export function queryRequest(data) {
    return request({
        url: base+'/query',
        method: 'post',
        data
    })
}

// 轨迹报告查询
export function trackReport(data) {
    return request({
        url: base+'/track-report',
        method: 'get',
        params: data
    })
}

//编辑
export function update(data) {
    return request({
        url: base+'/update',
        method: 'put',
        data
    })
}

//一键导入更新
export function importUpd(data) {
    return request({
        url: base+'/import-upd',
        method: 'post',
        data
    })
}

export function accountReport(data) {
    return request({
        url: base+'/report-export',
        method: 'post',
        data
    })
}

//物料更新模板下载
export function materialUpdTemplate() {
    return request({
        url: base+'/material-upd-template',
        method: 'get',
    })
}